const logo = () => {
  return {
    to: "/nga",
    image: {
      header: "helpcenter.ng.svg",
      footer: "1t4B9bQrPdx6C8Ym1mU1b-.svg"
    }
  };
};

const langs = () => {
  return [{ locale: "en" }, { locale: "yo" }, { locale: "ig" }];
};

const meta = banner => {
  return {
    logo: logo(),
    description: {
      to: "/nga",
      banner
    },
    API: process.env.VUE_APP_NG,
    langs: langs(),
    mask: "+### (###) ### - ####"
  };
};

export default {
  path: "/nga",
  children: [
    {
      path: "/nga/post=:post",
      name: "helpcenter.project",
      meta: meta("PostBanner")
    }
  ],
  name: "helpcenter.project",
  meta: meta("ProjectBanner"),
  component: () => import("@/views/Project.vue")
};
